/* OTUNBA — collection card click handler (fresh start 2026-05-23)
 *
 * Earlier approaches (CSS overlay anchor, z-index battles, pointer-events
 * hacks) all suffered from Shopify's stuck asset minification cache —
 * deployed source was correct but CDN kept serving old minified CSS.
 *
 * This JS approach sidesteps all of that. Listen for clicks at the
 * document level in CAPTURE phase (runs before any other listener).
 * If the click is inside .product-card-wrapper and not on an actual
 * interactive element, navigate to the product URL. Works regardless
 * of CSS positioning, z-index, or pointer-events. The deployed JS file
 * URL invalidates fresh whenever its content changes, so this dodges
 * the CSS minification pipeline entirely. */
(function () {
  if (window.__otunbaCardClick) return;
  window.__otunbaCardClick = true;

  function handler(e) {
    var wrapper = e.target.closest('.product-card-wrapper');
    if (!wrapper) return;

    // Skip clicks on real interactive elements that should keep their
    // own behavior — quick-add button, sale badge, the title's own
    // anchor (which already navigates natively via browser).
    var interactive = e.target.closest(
      'a[href]:not(.product-card__overlay-link), button, [role="button"], input, select, textarea, summary, label'
    );
    if (interactive) return;

    // Find a product URL inside the wrapper. Prefer the title heading's
    // anchor; fall back to any anchor pointing at /products/.
    var link = wrapper.querySelector('.card__heading a[href]') ||
               wrapper.querySelector('a[href*="/products/"]');
    if (!link || !link.href) return;

    // Honor cmd/ctrl/shift/middle-click for new tab behavior.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) {
      window.open(link.href, '_blank');
    } else {
      window.location.href = link.href;
    }
    e.preventDefault();
    e.stopPropagation();
  }

  // Capture phase so we run before any other handler.
  document.addEventListener('click', handler, true);

  // Visual affordance — cursor: pointer everywhere on the wrapper.
  function applyCursor() {
    var cards = document.querySelectorAll('.product-card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      cards[i].style.cursor = 'pointer';
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCursor);
  } else {
    applyCursor();
  }
  // Re-apply when collection-filter Section Rendering re-renders the grid.
  document.addEventListener('shopify:section:load', applyCursor);
})();
